<template>
  <section class="countries">
    <form method="post" @submit.prevent="onSend">
      <b-field horizontal :label="$t('attributes.name')">
        <b-input v-model="catalog.name" disabled expanded></b-input>
      </b-field>

      <b-field horizontal :label="$t('attributes.catalog_code')">
        <b-input v-model="catalog.catalog_no" disabled expanded></b-input>
      </b-field>

      <b-field horizontal :label="$t('attributes.national_flag')">
        <div class="content">
          <h3 class="has-text-info">
            {{ `最多只可選${maxCountry}個國旗` }}
          </h3>
        </div>
      </b-field>

      <b-field horizontal>
        <div class="columns is-multiline is-mobile">
          <b-checkbox
            v-for="country in countries"
            v-model="form.countries"
            :key="country.code"
            :native-value="country.code"
            class="column is-2 is-marginless"
            @input="onSelectCountry"
          >
            {{ country.name }}
          </b-checkbox>
        </div>
      </b-field>

      <b-field horizontal>
        <b-button
          :loading="sending"
          type="is-primary"
          native-type="submit"
          :style="{ width: '100%' }"
        >
          {{ $t('attributes.update_data') }}
        </b-button>
      </b-field>
    </form>

    <b-loading :active.sync="loading" :is-full-page="false"></b-loading>
  </section>
</template>

<script>
import { COUNTRY_TEMPLATES_API, CATALOG_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'CountriesForm',

  props: {
    catalog: {
      required: true,
      type: Object
    }
  },
  data() {
    const countries = this.catalog.countries
      ? this.catalog.countries.split(',').map(item => item.trim())
      : []

    return {
      loading: false,
      sending: false,

      maxCountry: 6,
      countries: [],
      form: {
        countries
      }
    }
  },
  watch: {
    catalog(group) {
      this.form.countries = group.countries
        ? group.countries.split(',').map(item => item.trim())
        : []
    }
  },
  mounted() {
    this.loadCountries()
  },
  methods: {
    async loadCountries() {
      const api = `${COUNTRY_TEMPLATES_API}/list`

      try {
        this.loading = true
        const res = await this.axios.get(api)
        let countries = res.data.data
        countries = countries.map(c => ({ ...c, code: c.code.trim() }))

        this.countries = countries
      } catch (e) {
        this.countries = []

        notifyService.fetch_error('country', e)
      } finally {
        this.loading = false
      }
    },
    onSelectCountry() {
      if (this.form.countries.length > this.maxCountry) {
        const countries = [...this.form.countries]
        countries.splice(-1, 1)

        this.$nextTick(function() {
          this.form.countries = [...countries]
        })
      }
    },
    async onSend() {
      if (this.form.countries.length === 0) {
        notifyService.error('至少需選擇一個國家')
      }

      const api = `${CATALOG_API}/${this.catalog.catalog_no}/countries`
      const data = {
        countries: this.form.countries.join(',')
      }

      try {
        this.sending = true
        const res = await this.axios.put(api, data)

        this.$emit('updated', res.data.data)
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
